'use strict';

var Marionette = require('backbone.marionette');

var ChildView = require('./selected-service-item').default;

export default Marionette.CollectionView.extend({

  tagName: 'ul',
  className: 'selected-service-list',
  childView: ChildView,

  filter: function (child, index, collection) {
    return this.appointment.hasService(child);
  },

  initialize: function (options) {
    this.appointment = options.appointment;
    this.listenTo(this.appointment, 'change:service_id', this.render);
  },

});
